@if (scrollService.showScrollButton()) {
<button class="scroll-btn" (click)="scrollService.scrollToTop()">
    <i class="bi bi-arrow-up"></i>
</button>
}